import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Box, Chip } from '@mui/material';
import { SelfServiceCampaignResponse } from '@provider-portal/common/api/gen/CampaignDeliveryProvider';

import { getPromotionState } from './utils';

interface PromotionDetailsTitleProps {
  promotion: SelfServiceCampaignResponse | null;
}

const styles = {
  chipUpcoming: {
    color: '#5B68F6',
    backgroundColor: '#EBECFF',
  },
  chipEnded: {
    color: '#A9B0B9',
    backgroundColor: '#F4F5F6',
  },
} as const;

export const PromotionDetailsTitle = ({ promotion }: PromotionDetailsTitleProps) => {
  const intl = useIntl();

  const state = useMemo(() => getPromotionState(promotion), [promotion]);
  const { title, chipLabel } = useMemo(() => {
    let chipState = state.toString();
    if (chipState === 'scheduled') {
      chipState = 'upcoming';
    }

    return {
      title: intl.formatMessage({ id: 'components.PromotionDetails.title' }),
      chipLabel: intl.formatMessage({ id: `components.PromotionDetails.state.${chipState}` }),
    };
  }, [intl, state]);

  return (
    <Box component="span" display="inline-flex" alignItems="center">
      <Box component="span" marginRight={1}>
        {title}
      </Box>

      {state === 'scheduled' ? (
        <Chip size="small" label={chipLabel} sx={styles.chipUpcoming} />
      ) : null}
      {state === 'ended' ? <Chip size="small" label={chipLabel} sx={styles.chipEnded} /> : null}
    </Box>
  );
};
